<img [style]="innerStyle" [src]="light ? logoService.light_path : logoService.dark_path" alt="logo" *ngIf="!logoService.loading; else loading">
<ng-template #loading>
    <mat-spinner diameter="20"></mat-spinner>
</ng-template>